import styled from 'styled-components'
import { color } from '../../GlobalStyle'
import { breakpoints } from '../../MediasQueries'

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
`

export const SectionSpacing = styled.div`
  margin-top: 22px;
`

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const ToggleDiv = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  background: ${({ theme }) => theme.background};
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);

  p {
    margin: 0;
    font-weight: 700;
  }
`

export const ItemGrid = styled.div`
  grid-column: ${(props) => props.start};
  padding-top: ${(props) => props.columnGap};
`

export const TotalGrid = styled.div`
  padding: 24px 20px 20px;

  @media screen and (max-width: ${breakpoints.md}) {
    padding: 18px 14px 16px;

    .check {
      height: 20px;
    }

    table thead {
      display: none;
    }

    table tr {
      border-bottom: 3px solid #e1e5e9;
      display: block;
      margin-bottom: 0.625em;
    }

    table th,
    table td {
      padding: 0.625em !important;
    }

    table td {
      border-bottom: 1px solid #e1e5e9;
      display: block;
      text-align: right;
      font-size: 16px;
      position: relative;
    }

    table td::before {
      display: table-cell;
      vertical-align: middle;
      content: attr(data-label);
      float: left;
      font-weight: bold;
      color: #000;
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
`

export const FormProduct = styled.form`
  height: 100%;
`

export const ButtonDiv = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    width: 320px;
  }
`

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 14px;

  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: repeat(14, minmax(auto, 1fr));

    div:nth-child(1) {
      grid-row: span 2;
    }

    div:nth-child(2) {
      grid-column: span 4;
    }

    .defaultSize {
      grid-column: span 2;
    }

    div:nth-child(8) {
      grid-row-start: 2;
      grid-column-end: -3;
    }

    div:nth-child(9) {
      grid-row-start: 2;
      grid-column-end: -1;
    }
  }
`

export const ComponentsDiv = styled.div`
  margin-top: 6px;
`

export const Components = styled.div`
  display: grid;
  margin-top: 16px;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
`

export const PlataformTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead th {
    text-align: left;
    padding: 16px 14px;
    font-size: 15px;
    font-weight: 700;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  tbody td {
    padding: 16px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
`

export const Tbody = styled.tbody`
  td {
    padding-top: 10px;
  }

  .price {
    font-weight: bold;
    color: ${color.brand};
  }

  .emptyState {
    min-height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    text-align: center !important;
    color: ${({ theme }) => theme.primary};
    opacity: 0.78;
  }

  .emptyState strong {
    font-size: 16px;
    font-weight: 700;
  }

  .emptyState span {
    font-size: 14px;
  }
`

export const Thead = styled.thead``

export const BarCodeContainer = styled.div`
  width: 50%;
  position: relative;
  margin-top: 8px;

  @media (max-width: ${breakpoints.xl}) {
    width: 100%;
  }

  .barcodeButton {
    position: absolute;
    right: 10px;
    bottom: 8px;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.background};
    border: 1px solid rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: 0.2s ease;
    padding: 0;
  }

  .barcodeButton:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .barcodeButton svg {
    font-size: 20px;
    color: ${({ theme }) => theme.primary};
  }
`